import { CARD_TYPES } from '../../../constants';

import { prepareGalleryCardData } from '../helpers/carouselHelper';

const getBackground = styleProperties => {
  const colors = [
    styleProperties?.title?.textColor,
    styleProperties?.subtitle?.textColor,
    styleProperties?.body?.textColor,
    styleProperties?.experienceText?.textColor,
  ].filter(Boolean);

  const background =
    colors.length > 1
      ? `linear-gradient(0deg, ${colors.reverse().join(', ')})`
      : colors[0] || null;
  return background;
};
export const prepareCardData = (cardData, data) => {
  const autoScroll =
    cardData?.properties?.internalName?.includes('autoplayTickerTape');
  const background = getBackground(cardData?.properties?.style?.properties);
  const bannerCardId = cardData?.properties?.title ?? cardData?.id ?? null;
  const preparedCards = prepareGalleryCardData(
    cardData,
    data,
    CARD_TYPES.STACKED_GALLERY,
    bannerCardId,
  );
  const addAnalyticsTags = preparedCards?.slides?.map(slide => ({
    ...slide,
    bannerCardId,
  }));

  return {
    ...preparedCards,
    autoScroll,
    backgroundGradient: background,
    sectionHeadline: null,
    slides: addAnalyticsTags,
  };
};

export const prepareTranslations = () => ({});

export {
  getGalleryUrlIngredients as getUrlIngredients,
  mergeGalleryProperties as mergeProperties,
} from '../helpers/carouselHelper/carouselHelper';

export {
  getGalleryActions as getAnalyticsActions,
  getGalleryPlacements as getAnalyticsPlacements,
} from '../helpers/analytics';

export { getBuyingToolsIngredients } from './common';
